import React from "react";
import "./Loader.scss";

export default function Loader({ loading = true }) {
	return (
		<div className={`loader-wrapper ${loading ? "" : "loaded"}`}>
			<div className="thunderbolt">
				<div className="shape1"></div>
			</div>
		</div>
	);
}
